import React from "react";

/**
 * Spike Sports wordmark.
 * - "SPIKE"  → glowing cyber-blue brand colour
 * - "SPORTS" → bright white (per brand guideline)
 * - Source PNG is brightened a touch via CSS filter so the mark reads on pure black.
 */
const SpikeLogo = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: { mark: "h-9",  textTop: "text-base",      textSub: "text-[0.6rem]"  },
    md: { mark: "h-11", textTop: "text-[1.25rem]", textSub: "text-[0.68rem]" },
    lg: { mark: "h-14", textTop: "text-2xl",       textSub: "text-[0.78rem]" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="spike-logo">
      <img
        src="/spike-logo.png"
        alt="Spike Sports"
        draggable={false}
        className={`${s.mark} w-auto object-contain select-none`}
        style={{ filter: "brightness(1.45) saturate(1.2) drop-shadow(0 0 12px rgba(31,169,240,0.45))" }}
      />
      <div className="leading-none">
        <div
          className={`font-orbitron font-black ${s.textTop} tracking-[0.22em] text-spike-blue-light`}
          style={{ textShadow: "0 0 18px rgba(31,169,240,0.55)" }}
        >
          SPIKE
        </div>
        <div
          className={`font-orbitron font-bold ${s.textSub} tracking-[0.46em] text-white mt-1`}
        >
          SPORTS
        </div>
      </div>
    </div>
  );
};

export default SpikeLogo;
